<template>
  <div class="search-lib-block" :class="{ show }" v-click-outside="close">
    <div class="target" @click="show = true">
      <img src="@/assets/icons/search.svg" alt="" />
    </div>
    <div class="input">
      <label>
        <input type="text" :placeholder="$t('libs.search.placeholder')" v-model="query" />
        <img class="search hide-mobile" src="@/assets/icons/search.svg" alt="" />
        <img class="close hide-pc" src="@/assets/icons/close-dark.svg" alt="" @click="close" />
      </label>
      <SearchLibResult :query="query" @clean="query = ''" />
    </div>
  </div>
</template>

<script>
import SearchLibResult from '@/components/libs/SearchLibResult'
import outsize from '@/mixins/outsize'

export default {
  name: 'SearchLib',
  components: { SearchLibResult },
  mixins: [outsize],
  data: () => ({
    show: false,
    query: '',
  }),
  computed: {},
  methods: {
    close() {
      this.show = false
      this.query = ''
    },
  },
}
</script>

<style lang="scss">
.search-lib-block {
  display: flex;
  max-width: calc(100% - 525px);
  transition: all 0.25s;

  @include mobile {
    position: absolute;
    z-index: 99;
    top: 100%;
    left: 0;
    max-width: unset;
    width: 35px;
    background: $white;
    box-shadow: 0 4.5px 21px rgba(0, 0, 0, 0.06);
    border-radius: 5px;

    &:not(.show) {
      label {
        width: 0;
        overflow: hidden;
      }
    }

    &.show {
      width: 100%;
    }
  }

  .target {
    @include flexCenter;
    flex-shrink: 0;
    width: 35px;
    height: 35px;
    flex-shrink: 0;

    @include PC {
      display: none;
    }
  }

  .input {
    position: relative;
    width: 100%;

    @include mobile {
      height: 35px;
    }

    @include PC {
      padding: 28px 28px 0;
      margin: -28px -28px 0;

      &::before {
        content: '';
        position: absolute;
        z-index: 11;
        left: 0;
        right: 30px;
        top: 10px;
        height: 54px;
        background: $white;
        border-radius: 5px;
      }
    }
  }

  label {
    position: relative;
    z-index: 11;
    width: 100%;
    margin: 0;
    transition: all 0.25s;
    background: $white;

    input {
      border: none;
      border-bottom: 1px solid rgba($dark, 0.2);
      border-radius: 0;
      width: 374px;
      max-width: 100%;
      transition: all 0.25s;
      padding-left: 0;
      font-weight: bold;
      font-size: 14px;
      line-height: 178.5%;

      @include mobile {
        border: none;
        height: 35px;
        width: 100%;
        padding: 0 34px 0 5px;
      }

      &:focus {
        border-bottom-color: rgba($dark, 0.5);
      }
    }

    img {
      position: absolute;
      top: 50%;
      right: 0;
      transform: translateY(-50%);

      @include mobile {
        padding: 10.5px;
      }
    }
  }
}
</style>
